import request from '@/config/axios'

export interface CashbackPlanVO {
  id?: number
  userId?: number
  nickname?: string
  avatar?: string
  mobile?: string
  orderId?: number
  orderNo?: string
  orderItemId?: number
  snapshotId?: number
  pieceIndex?: number
  pieceCount?: number
  spuId?: number
  spuName?: string
  totalPrice?: number
  dailyRate?: number
  dailyPrice?: number
  grantedPrice?: number
  remainPrice?: number
  status?: number
  adminPaused?: boolean
  afterSalePaused?: boolean
  firstGrantDate?: string
  lastGrantDate?: string
  receiveTime?: string
  closeReason?: string
  remark?: string
  createTime?: string
  canPause?: boolean
  canResume?: boolean
  canVoid?: boolean
  grants?: CashbackGrantVO[]
  opLogs?: CashbackPlanOpLogVO[]
}

export interface CashbackGrantVO {
  id?: number
  planId?: number
  userId?: number
  nickname?: string
  avatar?: string
  mobile?: string
  orderId?: number
  orderNo?: string
  spuName?: string
  grantDate?: string
  price?: number
  walletTransactionId?: number
  bizId?: string
  createTime?: string
}

export interface CashbackPlanOpLogVO {
  id?: number
  planId?: number
  opType?: string
  beforeJson?: string
  afterJson?: string
  reason?: string
  operatorId?: number
  createTime?: string
}

export const getCashbackPlanPage = async (params: any) => {
  return await request.get({ url: '/trade/cashback/plan/page', params })
}

export const getCashbackPlan = async (id: number) => {
  return await request.get({ url: '/trade/cashback/plan/get', params: { id } })
}

export const pauseCashbackPlan = async (data: { id: number; reason: string }) => {
  return await request.put({ url: '/trade/cashback/plan/pause', data })
}

export const resumeCashbackPlan = async (data: { id: number; reason: string }) => {
  return await request.put({ url: '/trade/cashback/plan/resume', data })
}

export const voidCashbackPlan = async (data: { id: number; reason: string }) => {
  return await request.put({ url: '/trade/cashback/plan/void', data })
}
